import type { InjectionKey } from 'vue';

export type GetFieldDefaultValue = (name: string) => unknown;
export const getFieldDefaultValueSymbol: InjectionKey<GetFieldDefaultValue>
  = Symbol('getFieldDefaultValue');

export type Field = {
  getValue: () => unknown;
  getIsInvisible: () => boolean;
};

export type Register = (name: string, field: Field) => () => void;

export const registerSymbol: InjectionKey<Register> = Symbol('register');
